
<div class="flex flex-col gap-4">
  <table class="w-full border-separate border-spacing-0 table-auto [&_th]:!border-[#EDE9E3] [&_td]:!border-[#EDE9E3]">
    <thead>
      <tr>
        <th
          colspan="3"
          class="!p-2 !text-center !align-middle text-[1rem] leading-[1rem] bg-[#F9F8F6] !font-medium border rounded-t-lg"
        >
          Container Exterior
        </th>
      </tr>
      <tr class="[&_th]:!p-2 [&_th]:!text-center [&_th]:!align-middle [&_th]:text-[0.75rem] [&_th]:leading-[0.75rem] [&_th]:!font-medium">
        <th class="border-x border-b bg-[#EEF4FF] text-[#3565FC]">L</th>
        <th class="border-b bg-[#F7FEE7] text-[#84CC16]">W</th>
        <th class="border-x border-b bg-[#F0FDFA] text-[#14B8A6]">H</th>
      </tr>
    </thead>
    <tbody>
      <tr class="[&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]">
        <td
          class="border-x rounded-bl-lg border-b !text-center !min-w-[5.5rem]"
        >
          {{ containerTypeSize.exterior.length }}
        </td>
        <td
          class="border-b !text-center !min-w-[5.5rem]"
        >
          {{ containerTypeSize.exterior.width }}
        </td>
        <td
          class="rounded-br-lg border-b border-x !text-center !min-w-[5.5rem]"
        >
          {{ containerTypeSize.exterior.height }}
        </td>
      </tr>
    </tbody>
  </table>
  <table class="w-full border-separate border-spacing-0 table-auto [&_th]:!border-[#EDE9E3] [&_td]:!border-[#EDE9E3]">
    <thead>
      <tr>
        <th
          colspan="3"
          class="!p-2 !text-center !align-middle text-[1rem] leading-[1rem] bg-[#F9F8F6] !font-medium border rounded-t-lg"
        >
          Container Interior
        </th>
      </tr>
      <tr class="[&_th]:!p-2 [&_th]:!text-center [&_th]:!align-middle [&_th]:text-[0.75rem] [&_th]:leading-[0.75rem] [&_th]:!font-medium">
        <th class="border-x border-b bg-[#EEF4FF] text-[#3565FC]">L</th>
        <th class="border-b bg-[#F7FEE7] text-[#84CC16]">W</th>
        <th class="border-x border-b bg-[#F0FDFA] text-[#14B8A6]">H</th>
      </tr>
    </thead>
    <tbody>
      <tr class="[&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]">
        <td
          class="border-x rounded-bl-lg border-b !text-center !min-w-[5.5rem]"
        >
          {{ containerTypeSize.interior.length }}
        </td>
        <td
          class="border-b !text-center !min-w-[5.5rem]"
        >
          {{ containerTypeSize.interior.width }}
        </td>
        <td
          class="rounded-br-lg border-b border-x !text-center !min-w-[5.5rem]"
        >
          {{ containerTypeSize.interior.height }}
        </td>
      </tr>
    </tbody>
  </table>
  <table class="w-full border-separate border-spacing-0 table-auto [&_th]:!border-[#EDE9E3] [&_td]:!border-[#EDE9E3]">
    <thead>
      <tr>
        <th
          colspan="2"
          class="!p-2 !text-center !align-middle text-[1rem] leading-[1rem] bg-[#F9F8F6] !font-medium border rounded-t-lg"
        >
          Door Opening
        </th>
      </tr>
      <tr class="[&_th]:!p-2 [&_th]:!text-center [&_th]:!align-middle [&_th]:text-[0.75rem] [&_th]:leading-[0.75rem] [&_th]:!font-medium">
        <th class="border-x border-b bg-[#F7FEE7] text-[#84CC16]">W</th>
        <th class="border-r border-b bg-[#F0FDFA] text-[#14B8A6]">H</th>
      </tr>
    </thead>
    <tbody>
      <tr class="[&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]">
        <td
          class="border-x rounded-bl-lg border-b !text-center !min-w-[5.5rem]"
        >
          {{ containerTypeSize.doorOpening.width }}
        </td>
        <td
          class="rounded-br-lg border-b border-r !text-center !min-w-[5.5rem]"
        >
          {{ containerTypeSize.doorOpening.height }}
        </td>
      </tr>
    </tbody>
  </table>
  <template v-if="!!containerTypeSize.cubicCapacity">
    <div class="flex gap-4 w-full">
      <table class="flex-1 border-separate border-spacing-0 table-auto [&_th]:!border-[#EDE9E3] [&_td]:!border-[#EDE9E3]">
        <thead>
          <tr class="[&_th]:!p-2 [&_th]:!text-center [&_th]:!align-middle [&_th]:text-[1rem] [&_th]:leading-[2rem] [&_th]:!font-medium">
            <th class="border rounded-t-lg bg-[#EEF4FF] ">Cubic Capacity</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-[#F9F8F6] [&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]">
            <td class="border-x rounded-b-lg border-b !text-center !min-w-[5.5rem]">
              <p class="p-0 m-0">
                {{ containerTypeSize.cubicCapacity }}
              </p>
              <p
                v-if="!!containerTypeSize.liquidCubicCapacity"
                class="p-0 m-0 opacity-60 text-[0.625rem] leading-[0.625rem]"
              >
                ({{ containerTypeSize.liquidCubicCapacity }})
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="flex-1 border-separate border-spacing-0 table-auto [&_th]:!border-[#EDE9E3] [&_td]:!border-[#EDE9E3]">
        <thead>
          <tr class="[&_th]:!p-2 [&_th]:!text-center [&_th]:!align-middle [&_th]:text-[1rem] [&_th]:leading-[2rem] [&_th]:!font-medium">
            <th class="border rounded-t-lg bg-[#FEFCE8]">Tare Weight</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-[#F9F8F6] [&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]">
            <td class="border-x rounded-b-lg border-b !text-center !min-w-[5.5rem]">{{ containerTypeSize.tareWeight }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex gap-4 w-full">
      <table class="flex-1 border-separate border-spacing-0 table-auto [&_th]:!border-[#EDE9E3] [&_td]:!border-[#EDE9E3]">
        <thead>
          <tr class="[&_th]:!p-2 [&_th]:!text-center [&_th]:!align-middle [&_th]:text-[1rem] [&_th]:leading-[2rem] [&_th]:!font-medium">
            <th class="border rounded-t-lg bg-[#ECFEFF]">Max Gross</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-[#F9F8F6] [&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]">
            <td class="border-x rounded-b-lg border-b !text-center !min-w-[5.5rem]">{{ containerTypeSize.maxGross }}</td>
          </tr>
        </tbody>
      </table>
      <table class="flex-1 border-separate border-spacing-0 table-auto [&_th]:!border-[#EDE9E3] [&_td]:!border-[#EDE9E3]">
        <thead>
          <tr class="[&_th]:!p-2 [&_th]:!text-center [&_th]:!align-middle [&_th]:text-[1rem] [&_th]:leading-[2rem] [&_th]:!font-medium">
            <th class="border rounded-t-lg bg-[#FFF7ED]">Max Payload</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-[#F9F8F6] [&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]">
            <td class="border-x rounded-b-lg border-b !text-center !min-w-[5.5rem]">{{ containerTypeSize.maxPayload }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
</div>
